import { inject, injectable } from "inversify";
import { ICPLClientPortalProposedWorkTypesClient, IntSelectModel } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IClientPortalProposedWorkTypesService {
  getProposedWorksTypesSelectModels(): Promise<IntSelectModel[]>;
}

@injectable()
export class ClientPortalProposedWorkTypesService implements IClientPortalProposedWorkTypesService {
  @inject(SERVICE_TYPES.CPLClientPortalProposedWorkTypesClient)
  cplClientPortalProposedWorkTypesClient!: ICPLClientPortalProposedWorkTypesClient;

  async getProposedWorksTypesSelectModels(): Promise<IntSelectModel[]> {
    return this.cplClientPortalProposedWorkTypesClient.getProposedWorksTypesSelectModels();
  }
}
